module.exports = __webpack_public_path__ + "img/f6.cf2b1b15.png";